import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface ParametroOrganizacaoExclusaoProps {
    show: boolean;
    onHide: () => void;
    idParametroOrganizacao: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function ParametroOrganizacaoExclusao(props: ParametroOrganizacaoExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoParametroOrganizacao, setCarregandoParametroOrganizacao] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoParametroOrganizacao(true);
            api.get(`/ParametroOrganizacao/${props.idParametroOrganizacao}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoParametroOrganizacao(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoParametroOrganizacao(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/ParametroOrganizacao/${props.idParametroOrganizacao}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir o parâmetros da organização: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoParametroOrganizacao
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir o parâmetros ${nome} da organização?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default ParametroOrganizacaoExclusao;